import { BoardSections, Project } from "../types";
import { getProjectsByStatus } from "./projects";
import { IProjectStatus } from "../../../@types/project/project-status.type";

export const initializeBoard = async (
  projects: Project[],
  projectStatus: IProjectStatus[]
): Promise<BoardSections> => {
  const boardSections: BoardSections = {};

  projectStatus.forEach((boardSectionKey) => {
    boardSections[boardSectionKey.name] = getProjectsByStatus(
      projects,
      boardSectionKey.name
    );
  });
  return boardSections;
};

export const findBoardSectionContainer = (
  boardSections: BoardSections,
  id: string
) => {
  if (id in boardSections) {
    return id;
  }

  let foundKey = null;

  for (const key in boardSections) {
    if (boardSections[key].some((item) => item.id === id)) {
      foundKey = key;
      break;
    }
  }
  return foundKey;

  // const container = Object.keys(boardSections).find((key) =>
  //   boardSections[key].find((item) => item.id === id)
  // );
  // return container;
};
